module.exports = __webpack_public_path__ + "img/pink_key-md.bdcca18b.jpg";